/** Main project script */

// ensure the main object is defined
if (typeof(gh) === 'undefined') {
    var gh = {};
}

// main code
gh.mags = {
    init: function () {
        this.megaMenuTrigger();
        this.searchPopoverTrigger();
        this.searchDesktopTrigger();
        this.makeHeaderWhite();
        $('[data-href]').addClass('jslink').on('click', function (e) {
            var target = $(this).data('href');
            window.location.href = target;
        });
        window.onscroll = function() { gh.mags.makeHeaderWhite() };
    },
    megaMenuTrigger: function () {
        $("#mega-menu-trigger").click(function(e) {
            e.preventDefault();
            gh.mags.closeSearchPopover();

            $(".header-main").toggleClass('mega-menu-open');
            $(".mega-menu").toggleClass('open');
        });
    },
    closeMegaMenu: function () {
        $(".header-main").removeClass('mega-menu-open');
        $(".mega-menu").removeClass('open');
    },
    searchDesktopTrigger: function () {
        var container = $('.desktop-search-form-container');
        $('.search-header-trigger-desktop').on('click', function (e) {
            e.preventDefault();
            $(this).parents(container).toggleClass('open');
        });
    },
    searchPopoverTrigger: function () {
        $('.search-popover .close-button').on('click', function (e) {
            e.preventDefault();
            gh.mags.closeSearchPopover();
            return false;
        });
        $(".search-popover-trigger").click(function(e) {
            e.preventDefault();
            gh.mags.closeMegaMenu();

            $(".header-main").toggleClass('search-popover-open');
            $(".search-popover-trigger").toggleClass('open');
            $(".search-popover, .suggestive-search-popover").toggleClass('open');

        });
    },
    closeSearchPopover: function () {
        $(".header-main").removeClass('search-popover-open');
        $(".search-popover-trigger").removeClass('open');
        $(".search-popover, .suggestive-search-popover").removeClass('open');
    },
    makeHeaderWhite: function () {

        var header = document.querySelector(".header-main");
        var threshold = 44;

        if (window.pageYOffset > threshold) {
            header.classList.add("header-white");
        } else {
            header.classList.remove("header-white");
            // if (header.classList.contains("home")) {
            //     header.classList.add("white");
            // }
        }

    },

};

$(document).ready(function () {
    gh.mags.init();
});
